import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-new-item-code',
  templateUrl: './new-item-code.component.html',
  styleUrls: ['./new-item-code.component.css']
})
export class NewItemCodeComponent implements OnInit {


  constructor(private formBuilder: FormBuilder) { }

  form: FormGroup;
  submitted: boolean = false;
  isSelected: boolean = false;
  users = [{

    "id": 1,
    "name": "Paul"
  }];

  controls = this.users.map(c => new FormControl(false));
  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl(),
      name: new FormControl(),
      description: new FormControl(),
    });
  }

  onSubmit() {

  }

}
